<div class="nts-file-uploader uploader content-box">
  <label #label class="nts-label-container" [style]="{ 'background-color': isHover ? '#1388900B' : 'inherit' }" [for]="uniqueId">
    @if (subtext) {
      <div><small [innerHTML]="trustedHtml"></small></div>
    }
    <input type="file" [id]="uniqueId" #fileInput (change)="filesAdd($event)" />
  </label>
</div>
